import { gql } from "@apollo/client";

export const GET_VIP_MEMBERS = gql`
  query GetVipMembers {
    getVipMembers {
      members {
        id
        tipperId
        userId
        username
        reinUsername
        isFanclubVip
        grantUntil
        lastSeen
        firstJoinedFanclub
        isStale
        isLinked
        linkSource
        discordName
        discordLinkedBy
        notOnDiscord
        notOnDiscordBy
        fanclubConfirmedAt
      }
      staleDays
      rolesPaused
      purchaseItem {
        type
        name
        isActive
      }
      lastSync {
        at
        by
        count
      }
    }
  }
`;

export const REVOKE_VIP = gql`
  mutation RevokeVip($tipperId: ID!) {
    revokeVip(tipperId: $tipperId)
  }
`;

const VIP_ROLE_SETTINGS_FIELDS = `
  botInServer
  canManageRoles
  selectedRoleId
  syncEnabled
  roles {
    id
    name
    color
    assignable
  }
`;

export const GET_DISCORD_VIP_ROLE_SETTINGS = gql`
  query GetDiscordVipRoleSettings {
    getDiscordVipRoleSettings {
      ${VIP_ROLE_SETTINGS_FIELDS}
    }
  }
`;

export const SET_DISCORD_VIP_ROLE = gql`
  mutation SetDiscordVipRole($roleId: String) {
    setDiscordVipRole(roleId: $roleId) {
      ${VIP_ROLE_SETTINGS_FIELDS}
    }
  }
`;

export const SET_VIP_ROLE_SYNC_ENABLED = gql`
  mutation SetVipRoleSyncEnabled($enabled: Boolean!) {
    setVipRoleSyncEnabled(enabled: $enabled) {
      ${VIP_ROLE_SETTINGS_FIELDS}
    }
  }
`;

const VIP_MEMBER_FIELDS = `
  id
  tipperId
  userId
  username
  reinUsername
  isFanclubVip
  grantUntil
  lastSeen
  firstJoinedFanclub
  isStale
  isLinked
  linkSource
  discordName
  discordLinkedBy
  notOnDiscord
  notOnDiscordBy
`;

export const SEARCH_DISCORD_MEMBERS = gql`
  query SearchDiscordMembers($query: String!) {
    searchDiscordMembers(query: $query) {
      id
      username
      displayName
      avatarUrl
    }
  }
`;

export const LINK_TIPPER_DISCORD = gql`
  mutation LinkTipperDiscord($tipperId: ID!, $discordId: String!) {
    linkTipperDiscord(tipperId: $tipperId, discordId: $discordId) {
      ${VIP_MEMBER_FIELDS}
    }
  }
`;

export const UNLINK_TIPPER_DISCORD = gql`
  mutation UnlinkTipperDiscord($tipperId: ID!) {
    unlinkTipperDiscord(tipperId: $tipperId) {
      ${VIP_MEMBER_FIELDS}
    }
  }
`;

export const UNLINK_USER_DISCORD = gql`
  mutation UnlinkUserDiscord($userId: ID!) {
    unlinkUserDiscord(userId: $userId) {
      ${VIP_MEMBER_FIELDS}
    }
  }
`;

export const MARK_TIPPER_NOT_ON_DISCORD = gql`
  mutation MarkTipperNotOnDiscord($tipperId: ID!) {
    markTipperNotOnDiscord(tipperId: $tipperId) {
      ${VIP_MEMBER_FIELDS}
    }
  }
`;

export const CLEAR_TIPPER_NOT_ON_DISCORD = gql`
  mutation ClearTipperNotOnDiscord($tipperId: ID!) {
    clearTipperNotOnDiscord(tipperId: $tipperId) {
      ${VIP_MEMBER_FIELDS}
    }
  }
`;

export const SYNC_FANCLUB_LIST = gql`
  mutation SyncFanclubList($list: String!, $apply: Boolean!) {
    syncFanclubList(list: $list, apply: $apply) {
      applied
      listCount
      added
      removed
      unchanged
      skipped
      currentCount
    }
  }
`;

export const SEARCH_VIP_CANDIDATES = gql`
  query SearchVipCandidates($query: String!) {
    searchVipCandidates(query: $query) {
      userId
      tipperId
      username
      reinUsername
      cbUsername
      grantUntil
    }
  }
`;

export const GRANT_VIP = gql`
  mutation GrantVip($userId: ID, $tipperId: ID, $days: Int!) {
    grantVip(userId: $userId, tipperId: $tipperId, days: $days)
  }
`;

export const END_VIP_GRANT = gql`
  mutation EndVipGrant($userId: ID, $tipperId: ID) {
    endVipGrant(userId: $userId, tipperId: $tipperId)
  }
`;

const VIP_PURCHASE_SETTINGS_FIELDS = `
  notifyRenewals
  item {
    type
    name
    isActive
  }
  options {
    type
    name
    cost
    isActive
  }
`;

export const GET_VIP_PURCHASE_SETTINGS = gql`
  query GetVipPurchaseSettings {
    getVipPurchaseSettings {
      ${VIP_PURCHASE_SETTINGS_FIELDS}
    }
  }
`;

export const SET_VIP_PURCHASE_ITEM = gql`
  mutation SetVipPurchaseItem($itemType: String, $notifyRenewals: Boolean) {
    setVipPurchaseItem(itemType: $itemType, notifyRenewals: $notifyRenewals) {
      ${VIP_PURCHASE_SETTINGS_FIELDS}
    }
  }
`;
